import { Box, Link } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { navigatePath, titleList } from "./parts";
import TkButton from "../../components/atoms/TkButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { httpAPI_APP101, httpAPI_APP106, httpAPI_APP107 } from "./api/request";
import {
  IAPI_APP101_Request,
  IAPI_APP101_Response,
  IAPI_APP106_Response,
} from "../../type/apiType";
import TkSelectForm from "../../components/atoms/TkSelectForm";
import { DemanderKbn, submitWay } from "../../assets/data/Constants";
import KikoHomeSearchForm from "./components/components";
import { ProcessInfoList } from "../../type/apiType/IAPI_APP101";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import SCRW150002 from "../SCRW150002";

/**
 * SCRW110001 機構職員ホーム
 * @return SCRW110001 機構職員ホーム
 */
const SCRW110001 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [showResult, setShowResult] = useState<boolean>(false);
  const [resultNum, setResultNum] = useState(0);
  const [bodyListData, setBodyListData] = useState<any>([]);
  const [allManagerList, setAllManagerList] = useState<any>([]);
  const [newManagerList, setNewManagerList] = useState<any>([]);
  const [openKiko, setOpenKiko] = useState(false);
  const [ListData, setListData] = useState<any>();
  const [res, setRes] = useState<IAPI_APP101_Response | IAPI_APP106_Response>(
    {}
  );
  const dataTableSelected = useRef<any[]>([]);
  const [filter, setFilter] = useState({});
  const [threadData, setThreadData] = useState({
    open: false,
    contractorNo: "",
    threadId: 0,
  });
  const date = new Date();
  const nowDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  const handleMove = (item: any) => {
    if (item.businessTypeCd === "JOB-45") {
      setThreadData({
        open: true,
        contractorNo: item.contractorNo,
        threadId: item.applyId,
      });
      return;
    }

    setBusinessState({
      searchForHome: businessState.searchForHome,
      common: {
        contractorNo: item.contractorNo,
        contractorName: item.applierName,
        businessType: item.businessTypeCd,
      },
    });

    navigate(navigatePath[item.businessTypeCd], {
      state: {
        applyId: item.applyId,
        contractorNo: item.contractorNo,
      },
    });
  };

  const getNewManager = (
    event: any,
    applyData: ProcessInfoList,
    managerList: any
  ) => {
    let managerName = managerList.find(
      (item: any) => item.managerUserId === event.target?.value
    )?.managerName;
    setNewManagerList((prev: any) => {
      if (event.target?.value) {
        const filteredPrev = prev.filter(
          (item: any) => item.applyId !== applyData.applyId
        );
        return [
          ...filteredPrev,
          {
            applyId: applyData.applyId,
            bussinessType: applyData.businessTypeName,
            prefecture: applyData.prefectureName,
            contractor: applyData.applierName,
            applyTime: applyData.applyTime,
            status: applyData.status,
            managerName: applyData.managerName,
            newManagerName: managerName,
            newManagerUserId: event.target.value,
          },
        ];
      } else {
        return prev.filter((item: any) => item.applyId !== applyData.applyId);
      }
    });
  };

  useEffect(() => {
    let managerList: any = res.managerList?.map((item) => {
      return {
        label: item.managerName,
        value: item.managerUserId,
      };
    });

    const bodyData = res.processInfoList?.map((item) => {
      return [
        {
          children: item.contractorNo
            ? (item.contractorNo ?? "") + ":" + (item.applierName ?? "")
            : item.applierName,
          className: item.corpApplyKbn === submitWay["紙"] ? "yellow" : "",
          forSort: item.contractorNo
            ? (item.contractorNo ?? "") + ":" + (item.applierName ?? "")
            : item.applierName,
        },
        {
          children: (
            <Box className="linkGroup">
              {((item.businessTypeCd === "JOB-35" &&
                item.demanderKbn !== DemanderKbn["退職者本人"]) ||
                item.businessTypeCd === "JOB-40" ||
                item.businessTypeCd === "JOB-41") && (
                <PriorityHighIcon className="priorityHighIcon" />
              )}
              <Link onClick={() => handleMove(item)} className="link">
                {item.businessTypeName}
              </Link>
            </Box>
          ),
          forSort: item.businessTypeName,
        },
        {
          children: item.applyTime,
          align: "center",
          forSort: item.applyTime,
        },
        {
          children: item.status,
          forSort: item.status,
        },
        {
          children: item.managerName,
          forSort: item.managerName,
        },
        {
          children: (
            <TkSelectForm
              type="selectFrom"
              label="新担当者"
              selectPropsList={managerList}
              onChange={(e: any) => getNewManager(e, item, res.managerList)}
            />
          ),
        },
      ];
    });
    setBodyListData(bodyData ?? []);
    setResultNum(bodyData?.length ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [res]);

  const handleInit = async (
    paramData: IAPI_APP101_Request,
    errorId?: string
  ) => {
    // 要処理一覧参照API 呼び出し
    try {
      const res = await httpAPI_APP101({ ...paramData });

      if (res.resultCd === "I0000") {
        setRes(res);

        let allManagerList: any = res.allManagerList?.map((item) => {
          return {
            label: item.wamName,
            value: item.wamUserId,
          };
        });
        setAllManagerList(allManagerList);

        if (paramData) {
          setShowResult(true);
          setFilter(paramData);
        }

        setBusinessState({
          searchForHome: paramData,
        });

        if (errorId !== "TKMSG_SVR0167E" && errorId !== "TKMSG_SVR0266E" && errorId !== "TKMSG_SVR0267E") {
          setState({
            ...state,
            errorMsgId: "",
          });
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setBodyListData([]);
        setResultNum(0);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit({
      ...businessState.searchForHome,
      manager: businessState.searchForHome
        ? businessState.searchForHome?.manager
        : state.authInfo?.userId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dataTableChange = (data: any) => {
    if (res.processInfoList?.length) {
      let selectData = data.map((item: any) => {
        return res.processInfoList![item];
      });

      dataTableSelected.current = selectData;
    }
  };

  const handleGroupApplicationUpdate = async () => {
    let reqData: any[] = [];
    let shouldOpenKiko = false;
    let cantClick = false;

    // グループ化できる業務タイプ
    const jobCodes = [
      "JOB-35",
      "JOB-42",
      "JOB-77",
      "JOB-14",
      "JOB-43",
      "JOB-50",
      "JOB-71",
      "JOB-75",
      "JOB-15",
      "JOB-70",
      "JOB-39",
    ];

    // 送金予定日の入力が必要な業務タイプ
    const needDueDateJobs = ["JOB-35", "JOB-42", "JOB-77", "JOB-71", "JOB-75"];

    dataTableSelected.current?.forEach((item: any) => {
      if (!jobCodes.includes(item.businessTypeCd)) {
        cantClick = true;
      }

      if (cantClick) return;

      let paramData: any = {
        applyId: item.applyId,
        businessType: item.businessTypeCd,
      };
      reqData.push(paramData);

      if (needDueDateJobs.includes(item.businessTypeCd)) {
        shouldOpenKiko = true;
      }
    });

    if (cantClick) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0100E",
      });
      return;
    } else {
      setState({
        ...state,
        errorMsgId: "",
      });
    }

    setListData(reqData);

    if (shouldOpenKiko) {
      setOpenKiko(true);
    } else {
      handleFalse(reqData);
    }
  };

  const handleOk = async (date?: any) => {
    try {
      setOpenKiko(false);
      const res = await httpAPI_APP107({
        applyList: ListData,
        transferDueDateForGroupApply: date,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        handleInit(filter);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        if (res.resultCd === "TKMSG_SVR0167E" || res.resultCd === "TKMSG_SVR0266E" || res.resultCd === "TKMSG_SVR0267E") {
          handleInit(filter, res.resultCd);
        }
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleFalse = async (ListData?: any) => {
    try {
      const res = await httpAPI_APP107({
        applyList: ListData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        handleInit(filter);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 稟議決裁一覧登録
  const handleRingiApproval = () => {
    if (!dataTableSelected.current.length) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0099E",
      });
      return;
    }

    setState({
      ...state,
      errorMsgId: "",
    });

    handleGroupApplicationUpdate();
  };

  // 一括承認
  const handleBulkApproval = async () => {
    if (!dataTableSelected.current.length) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0099E",
      });
      return;
    }

    setState({
      ...state,
      errorMsgId: "",
    });

    const selectedData = [...dataTableSelected.current];
    let reqData = selectedData.map((item: any) => {
      return {
        applyId: item.applyId,
        contractorNo: item.contractorNo,
      };
    });

    // 要処理一覧　状況更新API 実行
    try {
      const res = await httpAPI_APP106({
        applyList: reqData,
        screenId: "SCRW110001",
        ...filter,
      });

      if (res.resultCd === "I0000") {
        setRes(res);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleChangeManager = () => {
    let managerListSelected = newManagerList.filter((item: any) => {
      return dataTableSelected.current.find(
        (selected: any) => selected.applyId === item.applyId
      );
    });

    if (
      newManagerList?.length === 0 ||
      dataTableSelected.current.length === 0 ||
      managerListSelected.length === 0
    ) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0083E",
      });
      return;
    }

    setState({
      ...state,
      errorMsgId: "",
    });
    navigate("/SCRW110002", { state: { managerList: managerListSelected } });
  };

  const handleThreadClose = () => {
    setThreadData({ ...threadData, open: false });
    handleInit(filter);
  };

  return (
    <Box className="SCRW110001" data-testid="SCRW110001PageForTest">
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW110001_01}</TkInfoManual>

      <KikoHomeSearchForm
        managerList={allManagerList}
        defaultValue={businessState.searchForHome}
        showResult={showResult}
        resultNum={resultNum}
        onSearch={handleInit}
      />

      <Box className="btn">
        <TkButton onClick={handleRingiApproval}>稟議決裁一覧登録</TkButton>
        <TkButton onClick={handleBulkApproval}>一括承認</TkButton>
        <TkButton onClick={handleChangeManager}>担当者変更</TkButton>
      </Box>

      <TkDataTable
        headList={titleList}
        bodyList={bodyListData}
        checkSection={true}
        onCheckSectionWidth={dataTableChange}
        pagin={true}
      />
      <TkDateDialog
        open={openKiko}
        onOky={handleOk}
        onCancel={() => setOpenKiko(false)}
        minDate={nowDate}
        maxDate={new Date("2099/12/31")}
        title="送金予定日の登録"
        contextText="　送金予定日を指定して、「登録」ボタンを押してください。"
        cancelText="いいえ"
        okText="はい"
      />
      <SCRW150002 onClose={handleThreadClose} {...threadData} />
    </Box>
  );
};

export default SCRW110001;
